import { SmartTable } from '../../../../../components/smart-table/smart-table.model';
import {getDirectoryStatusTextKey} from '../../directory-integration.functions'

export class Controller {

    /** @ngInject */
    constructor($state, DirectoriesResource, Alert) {
        this.$state = $state;
        this.DirectoriesResource = DirectoriesResource;
        this.Alert = Alert;
    }

    $onInit() {
        this.st = new SmartTable();
    }

    getAzureStatus() {
        this.DirectoriesResource.getDirectoryStatus(
            this.companyId,
            this.directory,
        )
        .then((azureStatus) => {
            this.azureStatus = azureStatus;
            this.Alert('success', 'company.directory-integration.manage.sync-and-prov.refresh-status.success');
        })
        .catch((error) => {
            this.Alert('danger', error.data.message);
        });
    }

    azureSync() {
        this.DirectoriesResource.azureSync(
            this.companyId,
            this.directory.id,
        )
        .then(() => {
            this.$state.go('.', {}, { reload: '.' });
            this.Alert('success', 'company.directory-integration.manage.sync-and-prov.sync.success');
        })
        .catch((error) => {
            this.Alert('danger', error.data.message);
        });
    }

    azureProvisioning() {
        this.DirectoriesResource.azureProvisioning(
            this.companyId,
            this.directory.id,
        )
        .then(() => {
            this.$state.go('.', {}, { reload: '.' });
            this.Alert('success', 'company.directory-integration.manage.sync-and-prov.provisioning.success');
        })
        .catch((error) => {
            this.Alert('danger', error.data.message);
        });
    }

    getStatusKey() {
        return getDirectoryStatusTextKey(this.azureStatus.ongoingOperation);
    }

}



// WEBPACK FOOTER //
// ./src/portal/states/company/directory-integration/manage/domains-azure/directory-manage-domains-azure.controller.js